import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

export interface CreateOrderResp {
  orderId: string;
  amount: number; // paise
  currency: string;
  keyId: string; // public key
  name?: string;
}

export interface RazorpayResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export interface VerifyRequest { 
  paymentId: string;
  orderId: string;
  signature: string;
}


@Injectable({ providedIn: 'root' })
export class PaymentService {
  private base = `${environment.apiUrl}/payments`;

  constructor(private http: HttpClient) {}

  // Retry policy defaults
  private readonly DEFAULT_RETRIES = 3;
  private readonly BASE_DELAY_MS = 300; // base backoff

  private async retry<T>(fn: () => Promise<T>, attempts = this.DEFAULT_RETRIES): Promise<T> {
    let lastErr: any;
    for (let i = 0; i < attempts; i++) {
      try {
        return await fn();
      } catch (err: any) {
        lastErr = err;

        // If client error (4xx) don't retry
        const status = err?.status;
        if (status && status >= 400 && status < 500) {
          throw err;
        }

        // exponential backoff with jitter
        const backoff = this.BASE_DELAY_MS * Math.pow(2, i);
        const jitter = Math.floor(Math.random() * 100);
        const wait = backoff + jitter;
        await new Promise(res => setTimeout(res, wait));
      }
    }
    throw lastErr;
  }

  async createOrder(amountInRupees: number): Promise<CreateOrderResp> {
    const payload = { amount: amountInRupees, currency: 'INR', receipt: `receipt#${Date.now()}` };
    return this.retry(async () => {
      const resp = await firstValueFrom(this.http.post<CreateOrderResp>(`${this.base}/createOrder`, payload));
      return resp;
    });
  }

  async verifyPayment(payload: VerifyRequest): Promise<any> {
    return this.retry(async () => {
      const resp = await firstValueFrom(this.http.post<any>(`${this.base}/verifyCheckout`, payload));
      return resp;
    });
  }
}
